import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { ISubBrandCollection, ISubCategoryCollection } from 'src/app/shared/Models/ICategories';
import { IExtendPagination } from 'src/app/shared/Pagination/IPagination';
import { HomeService } from 'src/app/shared/services/home.service';
import { Product } from '../../../../shared/classes/product';

@Component({
  selector: 'app-brands',
  templateUrl: './brands.component.html',
  styleUrls: ['./brands.component.scss']
})
export class BrandsComponent implements OnInit {

  @Input() products: Product[] = [];
  @Input() brands: any[] = [];


  public subCategoryCollection$: Observable<ISubCategoryCollection[]>;
  public subCategoryCollection: ISubCategoryCollection[] =[];

  @Output() brandsFilter: EventEmitter<any> = new EventEmitter<any>();
  @Output() pagination: EventEmitter<IExtendPagination> = new EventEmitter<IExtendPagination>();
  @Output() subCategoryName: EventEmitter<string> = new EventEmitter<string>();

  public collapse: boolean = true;

  constructor(private _homeService: HomeService) { 
  }

  ngOnInit(): void {
    
    this.subCategoryCollection$ = this._homeService.getSubCategoryCollection$;
    
    this.subCategoryCollection$.subscribe(subCategories=>{
      
      if(subCategories)
      {
        subCategories.forEach(c=>{
          var code= localStorage.getItem('code');
          if(code)
          {
            c.subCategoryName = c.subCategoryNameInKurdish ? c.subCategoryNameInKurdish : c.mainSubCategoryName;
          }else{
            c.subCategoryName = c.mainSubCategoryName
          }
        })
      }

      this.subCategoryCollection = subCategories;
    })
  }

  get filterbyBrand() {
    const uniqueBrands = [];
    this.products.filter((product) => {
      if (product.brand) {
        const index = uniqueBrands.indexOf(product.brand)
        if (index === -1) uniqueBrands.push(product.brand)
      }
    })
    return uniqueBrands
  }

  appliedFilter(event) {
    let index = this.brands.indexOf(event.target.value);  // checked and unchecked value
    if (event.target.checked)   
      this.brands.push(event.target.value); // push in array cheked value
    else 
      this.brands.splice(index,1);  // removed in array unchecked value  
    
    let brands = this.brands.length ? { brand: this.brands.join(",") } : { brand: null };
    this.brandsFilter.emit(brands);
  }



  OnFilterSubCategory(subCategoryId: number,subCategoryName: string)
  {

    
    this.subCategoryName.emit(subCategoryName);
    this._homeService.loadSubBrandCollectionCollection(subCategoryId).subscribe();
  }

}
